import template from './teamRequestsList.html';
import controller from './teamRequestsList.controller';
import './teamRequestsList.scss';

let teamRequestsListComponent = {
  restrict: 'E',
  bindings: {
    requests: '<',
    onApproveAll: '&',
    employees : '<',
    loaded : '<',
    hasDelegations:'<',
    isDisabled: '<',
    isMobileApp: '<',
    onAction: '&'
  },
  template,
  controller
};

export default teamRequestsListComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsList.component.js